import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export const setAuthTokenInHeader = (token) => {
  if (token) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common['Authorization'];
  }
};

// Function to set loading state dynamically inside the interceptor
export const setupInterceptors = (setLoadingState) => {
  api.interceptors.request.use(
    (config) => {
      if (setLoadingState) setLoadingState(true);
      return config;
    },
    (error) => {
      if (setLoadingState) setLoadingState(false);
      return Promise.reject(error);
    }
  );

  api.interceptors.response.use(
    (response) => {
      if (setLoadingState) setLoadingState(false);
      return response;
    },
    (error) => {
      if (setLoadingState) setLoadingState(false);
      return Promise.reject(error);
    }
  );
};

export default api;
